import { useIsMutating } from "@tanstack/react-query";

import { feedbackToolKeys } from "@/hooks/queryKeys";

type MutationType = "CREATE" | "DELETE" | "RESOLVE" | "UPDATE";

export const useLoadingMutation = (
  mutation: MutationType,
  parentId: number,
) => {
  const mutationKey: Record<
    MutationType,
    ["feedback-tool", number | undefined]
  > = {
    CREATE: [...feedbackToolKeys.createFeedback(parentId)] as [
      "feedback-tool",
      number | undefined,
    ],
    DELETE: [...feedbackToolKeys.delete(String(parentId))] as [
      "feedback-tool",
      number | undefined,
    ],
    RESOLVE: [...feedbackToolKeys.resolve(String(parentId))] as [
      "feedback-tool",
      number | undefined,
    ],
    UPDATE: [...feedbackToolKeys.update(parentId)] as [
      "feedback-tool",
      number | undefined,
    ],
  };

  return useIsMutating({ mutationKey: mutationKey[mutation] });
};
